import type { ZoneOpts } from '../../game/netHooks';
import type { ZoneKind } from '../../zones/types';
import { COLOSSUS_ZONES, ColossusScript } from './colossus';
import { CrucibleScript } from './crucible';
import type { DeathView, HudView, InstanceEnv, ResultView } from './env';
import { GATES, GateScript } from './gates';
import { RIFT_ZONES, RiftScript } from './rift';
import type { InstanceScript, ScriptState } from './script';
import { STORY_DUNGEONS, StoryScript } from './story';

/** What the client and the UI see of the zone's instance script. */
export interface ActiveScript {
  readonly opts: ZoneOpts;
  readonly run: string;
  view(): HudView | null;
  deathView(): DeathView | null;
  resultView(): ResultView | null;
  action(id: string): void;
}

const has = (list: readonly string[], id: string): boolean => list.includes(id);

/** The instance script for a zone, or null for zones without one. */
export function createScript(zone: string, kind: ZoneKind, env: InstanceEnv, opts: ZoneOpts): InstanceScript<ScriptState> | null {
  if (kind === 'dungeon' && has(STORY_DUNGEONS, zone)) return new StoryScript(env, opts);
  if (has(RIFT_ZONES, zone)) return new RiftScript(env, opts, zone);
  if (has(COLOSSUS_ZONES, zone)) return new ColossusScript(env, opts, zone);
  if (GATES[zone]) return new GateScript(env, opts, zone);
  if (zone === 'crucible') return new CrucibleScript(env, opts);
  return null;
}
